.error{font-size:12px}
/*# sourceMappingURL=component-Q56WSXFV.css.map */
